import {
  clearPostLoginContext,
  LOGIN_REDIRECT_KEY,
} from "../../share-links/utils/shareAccessSession";

export function consumePostLoginRedirect(navigate) {
  const postLoginRedirectPath = sessionStorage.getItem(LOGIN_REDIRECT_KEY);
  if (!postLoginRedirectPath) {
    return false;
  }

  // Clear context keys first, then navigate with the captured path.
  clearPostLoginContext();

  if (typeof navigate === "function") {
    navigate(postLoginRedirectPath);
  } else {
    window.location.assign(postLoginRedirectPath);
  }
  return true;
}
